(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rootstone-master-menue"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 990px)');

    const initMasterMenu = (root) => {
      if (!root || root.dataset.rsInitialized === 'true') return;
      root.dataset.rsInitialized = 'true';

      const sectionElement = root.closest('.shopify-section') || root.parentElement;
      const megaDetails = [...root.querySelectorAll('[data-rs-mega-details]')];
      const drawer = root.querySelector('[data-rs-drawer]');
      const openButton = root.querySelector('[data-rs-drawer-open]');
      const closeButtons = [...root.querySelectorAll('[data-rs-drawer-close]')];
      const stickyEnabled = root.dataset.rsSticky === 'true';
      const stickyDesktopOffset = Number(root.dataset.rsStickyDesktopOffset || 0);
      const stickyMobileOffset = Number(root.dataset.rsStickyMobileOffset || 0);
      let lastFocusedElement = null;
      let stickyFrame = null;

      const stickyCandidates = new Set();
      if (stickyEnabled && sectionElement) {
        let sibling = sectionElement.previousElementSibling;
        while (sibling) {
          stickyCandidates.add(sibling);
          sibling
            .querySelectorAll('header, sticky-header, header-component, [data-header], [data-sticky-header]')
            .forEach((candidate) => stickyCandidates.add(candidate));
          sibling = sibling.previousElementSibling;
        }
      }

      const updateStickyPosition = () => {
        stickyFrame = null;
        if (!stickyEnabled || !sectionElement) return;

        let detectedHeaderBottom = 0;
        stickyCandidates.forEach((candidate) => {
          const styles = window.getComputedStyle(candidate);
          const isHeaderElement = candidate.matches(
            'header, sticky-header, header-component, [data-header], [data-sticky-header]'
          );
          const isPositioned = styles.position === 'sticky' || styles.position === 'fixed';
          if (!isHeaderElement && !isPositioned) return;
          if (styles.display === 'none' || styles.visibility === 'hidden') return;

          const rect = candidate.getBoundingClientRect();
          const isNearViewportTop = rect.top < Math.min(240, window.innerHeight * 0.35);
          const isVisibleAboveMenu = rect.bottom > 0 && rect.bottom < window.innerHeight * 0.6;
          if (rect.height > 0 && isNearViewportTop && isVisibleAboveMenu) {
            detectedHeaderBottom = Math.max(detectedHeaderBottom, rect.bottom);
          }
        });

        const manualOffset = desktopQuery.matches ? stickyDesktopOffset : stickyMobileOffset;
        const stickyTop = Math.max(0, Math.round(detectedHeaderBottom + manualOffset));
        sectionElement.style.setProperty('--rs-sticky-top', `${stickyTop}px`);

        const sectionTop = sectionElement.getBoundingClientRect().top;
        const isStuck = window.scrollY > 0 && Math.abs(sectionTop - stickyTop) < 2;
        sectionElement.classList.toggle('rs-master-menu-is-stuck', isStuck);
      };

      const requestStickyUpdate = () => {
        if (stickyFrame !== null) return;
        stickyFrame = window.requestAnimationFrame(updateStickyPosition);
      };

      const closeMegaMenus = (exception) => {
        megaDetails.forEach((details) => {
          if (details !== exception) details.removeAttribute('open');
        });
      };

      megaDetails.forEach((details) => {
        const item = details.closest('.rs-master-menu__item--mega');
        const summary = details.querySelector('summary');

        item?.addEventListener('pointerenter', (event) => {
          if (!desktopQuery.matches || event.pointerType === 'touch') return;
          closeMegaMenus(details);
          details.setAttribute('open', '');
        });

        item?.addEventListener('pointerleave', (event) => {
          if (!desktopQuery.matches || event.pointerType === 'touch') return;
          details.removeAttribute('open');
        });

        summary?.addEventListener('focus', () => {
          if (!desktopQuery.matches) return;
          closeMegaMenus(details);
          details.setAttribute('open', '');
        });
      });

      const openDrawer = () => {
        if (!drawer || !openButton) return;
        lastFocusedElement = document.activeElement;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        openButton.setAttribute('aria-expanded', 'true');
        document.body.classList.add('rs-master-menu-open');
        drawer.querySelector('[data-rs-drawer-close]')?.focus();
      };

      const closeDrawer = () => {
        if (!drawer || !openButton) return;
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        openButton.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('rs-master-menu-open');
        lastFocusedElement?.focus();
      };

      openButton?.addEventListener('click', openDrawer);
      closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

      document.addEventListener('click', (event) => {
        if (desktopQuery.matches && !root.contains(event.target)) closeMegaMenus();
      });

      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeMegaMenus();
          closeDrawer();
        }

        if (event.key !== 'Tab' || !drawer?.classList.contains('is-open')) return;
        const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled]), summary')]
          .filter((element) => element.offsetParent !== null);
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      desktopQuery.addEventListener('change', () => {
        closeMegaMenus();
        closeDrawer();
        requestStickyUpdate();
      });

      if (stickyEnabled) {
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });

        if ('ResizeObserver' in window) {
          const stickyResizeObserver = new ResizeObserver(requestStickyUpdate);
          stickyCandidates.forEach((candidate) => stickyResizeObserver.observe(candidate));
          stickyResizeObserver.observe(root);
        }

        requestStickyUpdate();
      }
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-rs-master-menu]').forEach(initMasterMenu);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
